import { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"
import { useUser } from "../../UserContext"
import { Button } from "../ui"
import MarketingCta from "./MarketingCta"
import {
  ascTuneUpSalesMailto,
  measurementStudioSalesMailto,
} from "./salesLinks"
import "./marketing.css"

const navItems = [
  ["Platform", "/product"],
  ["Pricing", "/pricing"],
  ["ASC TuneUp", "/asc-tuneup"],
  ["About", "/about"],
  ["Contact", "/contact"],
]

export default function MarketingLayout({ children }) {
  const user = useUser()
  const { pathname } = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const isAscTuneUp = pathname.startsWith("/asc-tuneup")
  const productLabel = isAscTuneUp ? "ASC TuneUp" : "Measurement Studio"
  const salesMailto = isAscTuneUp ? ascTuneUpSalesMailto : measurementStudioSalesMailto

  useEffect(() => {
    setMenuOpen(false)
    window.scrollTo({ top: 0, behavior: "auto" })
  }, [pathname])

  return (
    <div className="marketing-shell">
      <header className="marketing-header">
        <div className="marketing-header__inner">
          <Link className="marketing-brand" to="/" aria-label={`Jarbod ${productLabel} home`}>
            <span className="marketing-brand__mark" aria-hidden="true">J</span>
            <span className="marketing-brand__wordmark">
              <strong>Jarbod</strong>
              <small>{productLabel}</small>
            </span>
          </Link>
          <button
            className="marketing-menu-toggle"
            type="button"
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
            aria-controls="marketing-navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
          <div
            className={`marketing-header__content${menuOpen ? " marketing-header__content--open" : ""}`}
            id="marketing-navigation"
          >
            <nav className="marketing-nav" aria-label="Main navigation">
              {navItems.map(([label, to]) => (
                <NavLink
                  className={({ isActive }) => `marketing-nav__link${isActive ? " marketing-nav__link--active" : ""}`}
                  key={to}
                  to={to}
                >
                  {label}
                </NavLink>
              ))}
            </nav>
            <div className="marketing-header__actions">
              {!user && (
                <Button as={Link} to="/login" variant="ghost" size="sm">
                  Sign in
                </Button>
              )}
              {user ? (
                <MarketingCta size="sm" />
              ) : (
                <Button as="a" href={salesMailto} size="sm">Email sales</Button>
              )}
            </div>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className="marketing-footer">
        <div className="marketing-container marketing-footer__inner">
          <div className="marketing-footer__brand">
            <Link className="marketing-brand" to="/">
              <span className="marketing-brand__mark" aria-hidden="true">J</span>
              <span className="marketing-brand__wordmark">
                <strong>Jarbod</strong>
                <small>Measurement Studio</small>
              </span>
            </Link>
              <p>Analytics QA for agencies managing tags, GA4, and reporting quality across client accounts.</p>
          </div>
          <div className="marketing-footer__links">
            <div>
              <strong>Measurement Studio</strong>
              <Link to="/product">Platform</Link>
              <Link to="/pricing">Pricing</Link>
            </div>
            <div>
              <strong>Automotive</strong>
              <Link to="/asc-tuneup">ASC TuneUp</Link>
              <Link to="/asc-tuneup/features">Features</Link>
              <Link to="/asc-tuneup/pricing">Pricing</Link>
            </div>
            <div>
              <strong>Jarbod</strong>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
              <a href={measurementStudioSalesMailto}>Email sales</a>
              <Link to="/login">Sign in</Link>
            </div>
          </div>
        </div>
        <div className="marketing-container marketing-footer__bottom">
          <p>© {new Date().getFullYear()} Jarbod. All rights reserved.</p>
          <p>Measurement Studio and ASC TuneUp are products by Jarbod.</p>
        </div>
      </footer>
    </div>
  )
}

